import { render, staticRenderFns } from "./FontStyle.vue?vue&type=template&id=fb4aa68c"
import script from "./FontStyle.vue?vue&type=script&lang=js"
export * from "./FontStyle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports